(() => {
  if (customElements.get('cart-pairs-well')) return;

  class CartPairsWell extends HTMLElement {
    connectedCallback() {
      this.contentSlot = this.querySelector('.cart-pairs-well__slot');
      this.productId = null;
      this.loading = false;
      this.addEventListener('click', this.handleClick.bind(this));
      document.addEventListener('cart:updated', () => this.load(true));
      document.addEventListener('ajaxProduct:added', () => window.setTimeout(() => this.load(true), 350));
      this.load();
    }

    get rootPath() {
      return window.Shopify?.routes?.root || '/';
    }

    async load(force = false) {
      if (this.loading) return;
      this.loading = true;

      try {
        const cartResponse = await fetch(`${this.rootPath}cart.js`, {
          headers: { Accept: 'application/json' }
        });
        const cart = await cartResponse.json();
        const firstItem = cart.items?.find((item) => {
          const handle = String(item.handle || '').toLowerCase();
          const title = String(item.product_title || '').toLowerCase();
          return handle !== 'shipping-insurance' &&
            handle !== 'shipping-protection' &&
            !title.includes('shipping protection') &&
            !title.includes('gift:');
        });

        if (!firstItem) {
          this.hidden = true;
          this.contentSlot.innerHTML = '';
          this.productId = null;
          return;
        }

        if (!force && this.productId === firstItem.product_id && this.contentSlot.children.length) {
          this.hidden = false;
          return;
        }

        const getRecommendations = async (intent) => {
          const url = new URL(`${this.rootPath}recommendations/products`, window.location.origin);
          url.searchParams.set('section_id', 'cart-drawer-recommendations');
          url.searchParams.set('product_id', firstItem.product_id);
          url.searchParams.set('limit', '10');
          url.searchParams.set('intent', intent);
          const response = await fetch(url.toString());
          const html = await response.text();
          const documentFragment = new DOMParser().parseFromString(html, 'text/html');
          return documentFragment.querySelector('.cart-pairs-well__content');
        };

        let content = await getRecommendations('complementary');
        if (!content) content = await getRecommendations('related');

        this.contentSlot.innerHTML = content ? content.outerHTML : '';
        this.productId = firstItem.product_id;
        this.hidden = !content;
      } catch (error) {
        this.hidden = true;
      } finally {
        this.loading = false;
      }
    }

    handleClick(event) {
      const openButton = event.target.closest('[data-cart-pair-open]');
      const closeButton = event.target.closest('[data-cart-pair-close]');
      const confirmButton = event.target.closest('[data-cart-pair-confirm]');

      if (openButton) {
        this.openSelector(openButton.closest('.cart-pairs-well__card'));
      }

      if (closeButton) {
        closeButton.closest('dialog')?.close();
      }

      if (confirmButton) {
        this.addSelectedVariant(confirmButton);
      }

      if (event.target.matches('[data-cart-pair-dialog]')) {
        event.target.close();
      }
    }

    openSelector(card) {
      const dialog = this.querySelector('[data-cart-pair-dialog]');
      const select = dialog?.querySelector('[data-cart-pair-select]');
      const template = card?.querySelector('[data-cart-pair-options]');
      const title = card?.querySelector('[data-cart-pair-product-title]')?.textContent?.trim();

      if (!dialog || !select || !template) return;

      select.replaceChildren(template.content.cloneNode(true));
      dialog.querySelector('[data-cart-pair-dialog-title]').textContent = title || '';
      dialog.querySelector('[data-cart-pair-error]').textContent = '';
      dialog.showModal();
      select.focus();
    }

    async addSelectedVariant(button) {
      const dialog = button.closest('dialog');
      const select = dialog?.querySelector('[data-cart-pair-select]');
      const error = dialog?.querySelector('[data-cart-pair-error]');
      if (!select?.value) return;

      button.disabled = true;
      button.textContent = 'Adding…';
      error.textContent = '';

      try {
        const response = await fetch(`${this.rootPath}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [{ id: Number(select.value), quantity: 1 }]
          })
        });
        const result = await response.json();

        if (!response.ok) {
          throw new Error(result.description || 'This option could not be added.');
        }

        dialog.close();
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: result }
        }));
      } catch (requestError) {
        error.textContent = requestError.message;
      } finally {
        button.disabled = false;
        button.textContent = 'Add to cart';
      }
    }
  }

  customElements.define('cart-pairs-well', CartPairsWell);
})();

